import SimpleLightbox from "simplelightbox";

let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;

let lightbox = new SimpleLightbox(
  ".hd-content__gallery .hd-content__gallery--item",
  {
    captions: true,
    captionSelector: "self",
    captionPosition: "outside",
  }
);

function lightBoxPagination() {
  if (document.querySelector(".sl-caption")) {
    var currentCounter = document.querySelector(".sl-counter .sl-current");
    var totalCounter = document.querySelector(".sl-counter .sl-total");

    var caption = document.querySelector(".sl-caption");

    caption.setAttribute("data-current", currentCounter.innerText + " / ");
    caption.setAttribute("data-total", totalCounter.innerText);
  }
}

lightbox.on("shown.simplelightbox", function () {
  if (document.querySelector(".sl-caption")) {
    console.log("shown");
    var currentCounter = document.querySelector(".sl-counter .sl-current");
    var totalCounter = document.querySelector(".sl-counter .sl-total");

    var caption = document.querySelector(".sl-caption");

    caption.setAttribute("data-current", currentCounter.innerText + " / ");
    caption.setAttribute("data-total", totalCounter.innerText);
  }

  document.querySelector(".sl-next").addEventListener("click", function () {
    setTimeout(() => {
      if (document.querySelector(".sl-caption")) {
        console.log("nextdone");
        var currentCounter = document.querySelector(".sl-counter .sl-current");
        var totalCounter = document.querySelector(".sl-counter .sl-total");

        var caption = document.querySelector(".sl-caption");

        caption.setAttribute("data-current", currentCounter.innerText + " / ");

        caption.setAttribute("data-total", totalCounter.innerText);
      }
    }, 1);
  });

  document.querySelector(".sl-prev").addEventListener("click", function () {
    setTimeout(() => {
      if (document.querySelector(".sl-caption")) {
        console.log("nextdone");
        var currentCounter = document.querySelector(".sl-counter .sl-current");
        var totalCounter = document.querySelector(".sl-counter .sl-total");

        var caption = document.querySelector(".sl-caption");

        caption.setAttribute("data-current", currentCounter.innerText + " / ");

        caption.setAttribute("data-total", totalCounter.innerText);
      }
    }, 1);
  });

  document
    .querySelector(".sl-wrapper")
    .addEventListener("touchend", function () {
      console.log("howdy");
      setTimeout(() => {
        if (document.querySelector(".sl-caption")) {
          console.log("nextdone");
          var currentCounter = document.querySelector(
            ".sl-counter .sl-current"
          );
          var totalCounter = document.querySelector(".sl-counter .sl-total");

          var caption = document.querySelector(".sl-caption");

          caption.setAttribute(
            "data-current",
            currentCounter.innerText + " / "
          );

          caption.setAttribute("data-total", totalCounter.innerText);
        }
      }, 1);
    });
});

lightbox.on("changed.simplelightbox", function () {
  if (document.querySelector(".sl-caption")) {
    console.log("nextdone");
    var currentCounter = document.querySelector(".sl-counter .sl-current");
    var totalCounter = document.querySelector(".sl-counter .sl-total");

    var caption = document.querySelector(".sl-caption");

    caption.setAttribute("data-current", currentCounter.innerText + " / ");

    caption.setAttribute("data-total", totalCounter.innerText);
  }
});
